import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import React from 'react';

import { theme } from '../../services/theme';

export const ProfileOption = (props: {
  name: string;
  value: string;
  icon: React.ReactNode;
}) => (
  <ListItem
    sx={{
      border: '1px solid #9AB1C0',
      borderRadius: '8px',
      height: '52px',
      margin: '0px 0px 16px 0px',
      padding: '8px 20px',
      [theme.breakpoints.down('sm')]: {
        padding: '5px 11px',
      },
    }}
  >
    <ListItemAvatar
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        maxWidth: '40px',
        minWidth: '40px',
      }}
    >
      {props.icon}
    </ListItemAvatar>
    <ListItemText
      primary={props.name}
      primaryTypographyProps={{
        color: '#9AB1C0',
        fontSize: '11px',
        fontWeight: '500',
      }}
      secondary={props.value}
      secondaryTypographyProps={{
        color: '#260F26',
        fontSize: '14px',
        fontWeight: '400',
      }}
    />
  </ListItem>
);
